/**
 * What feeds a Social Spend Target Definition's Actuals, and whether it carries
 * a target at all — two axes, four values.
 *
 * SOURCE is invoices or generated employee cost, and stays **exclusive**: one
 * of the two is always the whole figure and the other always zero, so nothing
 * is ever subtracted from anything. Every value below is single-sourced.
 *
 * TARGET is a stated figure or tracking-only. The `*Total` values carry none;
 * their stored `target_value` is 0, which `expectedByNow` reads as no
 * commitment — exclude them explicitly; see `utils/trackingTargets`.
 *
 * Because SOURCE spans two values each, **never compare against a single value
 * to ask "is this employee-cost?"** — use `isEmployeeCostSourced`. Comparing
 * directly is how a tracking definition ends up generating no cost rows and
 * totalling zero, silently.
 */
export var ProjectSocialSpendCommitmentType;
(function (ProjectSocialSpendCommitmentType) {
    /** Invoiced Social Spend only. The default, and today's behaviour. */
    ProjectSocialSpendCommitmentType["Invoice"] = "project-social-spend-commitment-type_invoice";
    /**
     * Generated employee cost only. Invoices are *excluded* from this Target
     * Definition rather than merely absent — without that, one configuring no
     * supplier filters would match every invoice on the Project.
     */
    ProjectSocialSpendCommitmentType["EmployeeCost"] = "project-social-spend-commitment-type_employee-cost";
    /** Invoiced Social Spend, tracked with no target value. */
    ProjectSocialSpendCommitmentType["InvoiceTotal"] = "project-social-spend-commitment-type_invoice-total";
    /** Generated employee cost, tracked with no target value. */
    ProjectSocialSpendCommitmentType["EmployeeCostTotal"] = "project-social-spend-commitment-type_employee-cost-total";
})(ProjectSocialSpendCommitmentType || (ProjectSocialSpendCommitmentType = {}));
export const projectSocialSpendCommitmentTypeToString = (targetType) => {
    switch (targetType) {
        case ProjectSocialSpendCommitmentType.Invoice:
            return "Invoiced Spend";
        case ProjectSocialSpendCommitmentType.EmployeeCost:
            return "Employee Cost";
        case ProjectSocialSpendCommitmentType.InvoiceTotal:
            return "Invoiced Spend (Total)";
        case ProjectSocialSpendCommitmentType.EmployeeCostTotal:
            return "Employee Cost (Total)";
    }
};
